import React from 'react';
import { IconProps } from '../types';

interface CustomIconProps extends IconProps {
  viewBox?: string;
  role?: string;
  'aria-hidden'?: boolean;
}

export const SsfShortformOn = React.memo<CustomIconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
    width,
    height,
    role = 'img',
    'aria-hidden': ariaHidden = false,
  }) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      className={className}
      onClick={onClick}
      role={role}
      aria-hidden={ariaHidden}
      style={{ cursor: onClick ? 'pointer' : 'inherit' }}
    >
      <path
        d="M3 16H17"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M16 3.40039C16.8837 3.40039 17.5996 4.11634 17.5996 5V12C17.5996 12.8837 16.8837 13.5996 16 13.5996H4C3.11634 13.5996 2.40039 12.8837 2.40039 12V5C2.40039 4.11634 3.11634 3.40039 4 3.40039H16ZM9.62012 6.57324C9.35643 6.38435 9.00004 6.58353 9 6.91992V10.0801C9.00005 10.4165 9.35643 10.6157 9.62012 10.4268L11.8262 8.84668C12.0579 8.68031 12.0579 8.31969 11.8262 8.15332L9.62012 6.57324Z"
        fill="white"
      />
    </svg>
  ),
);

SsfShortformOn.displayName = 'SsfShortformOn';
